import { NavLink, Outlet } from 'react-router-dom'

import { LogoutButton } from '../components/LogoutButton'
import { ThemeMobileHeaderControl } from '../components/theme'
import { useUserAuthorization } from '../context/UserAuthorizationContext'
import { filterNavByAccess } from '../lib/userNavAccess'
import { useTheme } from '../theme/ThemeContext'

export function AppLayout() {
  const { theme } = useTheme()
  const { permissions } = useUserAuthorization()
  const isGlass = theme === 'glass'
  const angular = theme === 'pixel' || theme === 'geek'

  const nav = filterNavByAccess(permissions)

  const barClass = isGlass
    ? 'shell-nav glass-chrome glass-chrome-solid border-b border-[var(--shell-nav-border)]'
    : 'shell-nav chrome-bar border-b'
  const asideClass = [
    'shell-nav hidden w-64 shrink-0 flex-col border-r border-[var(--shell-nav-border)] lg:flex',
    isGlass ? 'glass-chrome' : '',
  ].join(' ')
  const bottomClass = isGlass
    ? 'shell-nav glass-chrome glass-chrome-solid border-t border-[var(--shell-nav-border)]'
    : 'shell-nav chrome-bar border-t'

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <header
        className={`z-40 flex h-14 shrink-0 items-center justify-between gap-3 px-4 lg:hidden ${barClass}`}
      >
        <div className="min-w-0 shrink">
          <div className="font-display text-lg font-semibold tracking-tight text-ink">
            GlyphicAI
          </div>
        </div>
        <ThemeMobileHeaderControl />
      </header>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden lg:flex-row">
      <aside className={`${asideClass} h-full min-h-0 overflow-hidden`}>
        <div
          className={`shrink-0 px-6 py-7 ${isGlass ? 'border-b border-white/[0.12]' : angular ? 'border-b-2 border-[var(--shell-nav-border)]' : 'border-b border-[var(--shell-nav-border)]'}`}
        >
          <div className="font-display text-xl font-semibold tracking-tight text-ink">
            GlyphicAI
          </div>
        </div>
        <nav className="scroll-region flex flex-1 min-h-0 flex-col gap-1 overflow-y-auto p-4">
          {nav.map((item) => {
            const Icon = item.Icon
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  [
                    'flex items-start gap-3 rounded-[var(--radius-sm)] px-3 py-3 text-left transition-colors',
                    isActive
                      ? isGlass
                        ? 'bg-menu-solid text-ink shadow-sm ring-1 ring-line'
                        : 'bg-surface-muted text-ink shadow-sm'
                      : 'text-ink-soft hover:bg-surface-muted/80 hover:text-ink',
                  ].join(' ')
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={[
                        'mt-0.5 shrink-0 [&_svg]:block',
                        isActive ? 'text-accent' : 'text-ink-soft',
                      ].join(' ')}
                    >
                      <Icon className="h-5 w-5" />
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm font-semibold">{item.label}</span>
                      <span className="mt-0.5 block text-xs opacity-80">{item.desc}</span>
                    </span>
                  </>
                )}
              </NavLink>
            )
          })}
        </nav>
        <div
          className={`shrink-0 space-y-3 p-4 ${isGlass ? 'border-t border-white/[0.12]' : angular ? 'border-t-2 border-[var(--shell-nav-border)]' : 'border-t border-[var(--shell-nav-border)]'}`}
        >
          <LogoutButton variant="sidebar" />
        </div>
      </aside>

      <main className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden bg-[var(--shell-content-bg)] lg:pb-0">
        <div className="shell-content flex min-h-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </div>
      </main>

      <nav
        className={`z-40 flex min-w-0 shrink-0 overflow-x-hidden pb-[env(safe-area-inset-bottom,0px)] pt-0 lg:hidden ${bottomClass}`}
      >
        {nav.map((item) => {
          const Icon = item.Icon
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  'flex min-h-[3rem] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-0.5 text-[10px] font-semibold transition-colors sm:px-1 sm:text-[11px]',
                  isActive ? 'text-accent' : 'text-ink-soft',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className={isActive ? 'h-5 w-5' : 'h-5 w-5 opacity-85'} />
                  <span>{item.short}</span>
                </>
              )}
            </NavLink>
          )
        })}
      </nav>
      </div>
    </div>
  )
}
